.title {
	color: var(--ds-text-subtlest, var(--adg3-color-N200));
	text-transform: uppercase;
	font-weight: bold;
	font-size: 11px;
	padding-left: var(--jpo-common-base-spacing);
	height: calc(4 * var(--jpo-common-base-spacing));
	display: flex;
	align-items: center;
	border-radius: 0px 3px 3px 0px;
	margin-right: calc(0.5 * var(--jpo-common-base-spacing));
}
